// extracted by mini-css-extract-plugin
module.exports = {"link":"_2f5Ce","image":"_3mKvC","root":"_1A4nG"};